export function generatePassword(length = 32, letters = true, numbers = true, symbols = true, spaces = false): string {
  const chars = []
  if (letters) chars.push(
    'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k',
    'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v',
    'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G',
    'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R',
    'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z',
  )
  if (numbers) chars.push(
    '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
  )
  if (symbols) chars.push(
    '~', '!', '#', '$', '%', '^', '&', '*', '(', ')', '-',
    '_', '.', ',', '<', '>', '?', '/', '\\', '{', '}', '[',
    ']', '|', ':', ';',
  )
  if (spaces) chars.push(
    ' '
  )
  const charsString = chars.join('')
  let password = ''
  for (let i = 0; i < length; i++) {
    password += charsString.charAt(Math.floor(Math.random() * charsString.length))
  }
  return password
}
